/** Calculates the rate per mile for a given load. */
export function calculateRatePerMile(
  miles: number | null | undefined,
  rate: number | null | undefined
): number | null {
  if (!miles || miles === 0) return null;
  return rate ? rate / miles : null;
}
